<template>
    <div class="slide">

        <go-back />

        <div class="next" @click="next">
            <img src="/assets/img/icon-arrow-right-blue.svg" />
        </div>

        <div class="slide-container">

            <div class="question">
                Approximately how much are you <span>saving each year</span>?
            </div>

            <div class="answer answer-col">

                <div class="row no-margin-bottom">
                    <div class="col-md-4">
                        <v-text-field
                                v-model="savingsAccount.value"
                            label="How much yearly $" class="inputNumber"
                        ></v-text-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <p class="sub-question">
                            For how long do you see you can continue these savings?
                        </p>
                        <div class="sub-answer">
                            <span class="sub-alternative display-flex-grow-1" v-bind:class="{ active: savingsAccount.stop_year_formula === 'retirement' }" @click="savingsAccount.stop_year_formula = 'retirement'">Until Retirement</span>
                            <span class="sub-alternative display-flex-grow-1" v-bind:class="{ active: savingsAccount.stop_year_formula === 'life_exp' }" @click="savingsAccount.stop_year_formula = 'life_exp'">Until Life Expectancy</span>
                            <span class="sub-alternative display-flex-grow-1" v-bind:class="{ active: savingsAccount.stop_year_formula === 'specific_age' }" @click="savingsAccount.stop_year_formula = 'specific_age'">Until Specific Age</span>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="savingsAccount.stop_year_formula === 'specific_age'">
                    <div class="col-md-12">
                        <label class="label-slider">Until I am&nbsp;<span>{{ savingsAccount.specific_age_to_stop }}</span></label>
                        <v-slider
                            v-model="savingsAccount.specific_age_to_stop"
                            class="align-center"
                            :max="100"
                            :min="min"
                            hide-details
                            track-color="#e0e0e0"
                        >
                        </v-slider>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import GoBack from "./GoBack";
    export default {
        name: 'Savings',
        components: {
            GoBack
        },
        mounted() {
            this.$store.dispatch('accounts/loadSavingsAccount');
        },
        methods: {
            next() {
                this.$store.dispatch('accounts/saveSavingsAccount');
                this.$router.push({ name: 'SectionThree' });
            }
        },
        created() {
            this.min = this.personOne.current_age;
        },
        data() {
            return {
                min: 0,
            }
        },
        computed: {
            ...mapGetters('individuals', [
                'personOne',
            ]),
            ...mapGetters('accounts', [
                'savingsAccount'
            ]),
        }
    }
</script>
